<ng-container *ngIf="(loading$ | async) === false; else loadingTemplate">
  <div class="grid">
    <div class="col-12">
      <p-card>
        <div class="p-fluid">
          <div class="field">
            <label class="font-medium required-field">Название на русском</label>
            <crm-input-text
              [(value)]="currency.name"
              [isError]="$any(errors?.name)"></crm-input-text>
            <small
              *ngIf="errors?.name"
              class="p-error">
              {{ errors.name | join }}
            </small>
          </div>

          <div class="field">
            <label class="font-medium required-field">Название на английском</label>
            <crm-input-text
              [(value)]="currency.nameEnglish"
              [isError]="$any(errors?.nameEnglish)"></crm-input-text>
            <small
              *ngIf="errors?.nameEnglish"
              class="p-error">
              {{ errors.nameEnglish | join }}
            </small>
          </div>

          <div class="field">
            <label class="font-medium">Номинал</label>
            <p-inputNumber
              [(ngModel)]="currency.denomination"
              [ngClass]="{ 'ng-invalid ng-dirty': errors?.denomination }"></p-inputNumber>
            <small
              *ngIf="errors?.denomination"
              class="p-error">
              {{ errors.denomination | join }}
            </small>
          </div>

          <div class="field">
            <label class="font-medium required-field">Цифровой код</label>
            <crm-input-text
              [(value)]="currency.isoNumeric"
              [isError]="$any(errors?.isoNumeric)"></crm-input-text>
            <small
              *ngIf="errors?.isoNumeric"
              class="p-error">
              {{ errors.isoNumeric | join }}
            </small>
          </div>

          <div class="field">
            <label class="font-medium required-field">Символьный код</label>
            <crm-input-text
              [(value)]="currency.isoCharacter"
              [isError]="$any(errors?.isoCharacter)"></crm-input-text>
            <small
              *ngIf="errors?.isoCharacter"
              class="p-error">
              {{ errors.isoCharacter | join }}
            </small>
          </div>
        </div>
      </p-card>
    </div>
  </div>

  <div class="mt-3">
    <div class="flex flex-wrap justify-content-between">
      <button
        pButton
        class="p-button-success"
        [label]="saveButtonLabel"
        (click)="saveCurrency()"></button>

      <button
        *ngIf="(form$ | async)?.isShowDelete"
        pButton
        label="Удалить"
        class="p-button-danger p-button-text"
        (click)="deleteCurrency()"></button>
    </div>
  </div>
</ng-container>

<ng-template #loadingTemplate>
  <crm-spinner></crm-spinner>
</ng-template>
